import { html, mount } from '../core/html.js';
import { put, session, refreshMe, hasRole, isStaff, changeLocale } from '../core/api.js';
import { toast, showError, initials } from '../core/ui.js';
import { t, locales, getLocale } from '../core/i18n.js';
import { logout } from '../app.js';
import { telegramCard, bindTelegram } from './shared/telegram.js';

export async function render(main) {
  const me = session.me;
  mount(main, html`<div class="wrap" style="max-width:640px;padding-top:20px">
    <div class="row"><span class="avatar" style="width:64px;height:64px;font-size:22px">${initials(me.name)}</span><div><h1 style="margin:0" data-ugc>${me.name}</h1><div class="muted" data-ugc>${me.email || ''}</div></div></div>
    <div class="list" style="margin-top:20px">
      ${hasRole('HOST') ? html`<a class="item" href="#/host"><span class="grow"><b>${t('profile.host_area')}</b><div class="small muted">${t('profile.host_area_text')}</div></span></a>` : html`<a class="item" href="#/become-host"><span class="grow"><b>${t('nav.become_host')}</b><div class="small muted">${t('profile.become_host_text')}</div></span></a>`}
      ${isStaff() ? html`<a class="item" href="#/admin"><span class="grow"><b>${t('nav.admin')}</b><div class="small muted">${t('profile.admin_text')}</div></span></a>` : ''}
      <a class="item" href="#/notifications"><span class="grow"><b>${t('nav.notifications')}</b></span></a>
      <a class="item" href="#/bookings?tab=completed"><span class="grow"><b>${t('profile.history')}</b></span></a>
      <a class="item" href="#/support"><span class="grow"><b>${t('profile.help')}</b></span></a>
    </div>
    <div style="margin-top:20px">${telegramCard()}</div>
    <form id="pf" class="panel stack" style="margin-top:20px"><h2>${t('profile.personal')}</h2>
      <label class="field"><span>${t('field.name')}</span><input class="input" name="name" value="${me.name}" required minlength="2"></label>
      <label class="field"><span>${t('field.phone')}</span><input class="input" name="phone" value="${me.phone || ''}" type="tel"></label>
      <label class="field"><span>${t('profile.language')}</span><select class="input" name="locale">${locales.map((l) => html`<option value="${l.code}" lang="${l.code}" ${l.code === getLocale() ? 'selected' : ''}>${l.name}</option>`)}</select></label>
      <p class="small muted">${t('profile.language_hint')}</p>
      <button class="btn btn-primary">${t('common.save_changes')}</button></form>
    <button class="btn btn-ghost btn-block" id="out" style="margin-top:16px">${t('nav.logout')}</button></div>`);
  bindTelegram(main);
  main.querySelector('#pf').onsubmit = async (e) => {
    e.preventDefault();
    const f = Object.fromEntries(new FormData(e.target).entries());
    try {
      await put('/api/me', { name: f.name, phone: f.phone || undefined });
      await refreshMe();
      toast(t('common.saved'));
      if (f.locale !== getLocale()) await changeLocale(f.locale);
    } catch (err) { showError(err); }
  };
  main.querySelector('#out').onclick = logout;
}
